module.exports = __webpack_public_path__ + "static/home8-63adab31a34abe9935ac8c822752cba4.jpg";